import { render } from "./AdminCareGivers.vue?vue&type=template&id=2fea1cd0&scoped=true"
import script from "./AdminCareGivers.vue?vue&type=script&lang=js"
export * from "./AdminCareGivers.vue?vue&type=script&lang=js"

import "./AdminCareGivers.vue?vue&type=style&index=0&id=2fea1cd0&scoped=true&lang=css"
import "./AdminCareGivers.vue?vue&type=style&index=1&id=2fea1cd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fea1cd0"]])

export default __exports__